export default class GetAllGradosPromocion {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllGradosPromocion()
      return result
    } catch (error) {
      console.error('Error al obtener los grados de promoción:', error)
      throw error
    }
  }
}
